import type { Locale } from "../types";

export type LocaleConfig = {
  id: Locale;
  name: string;
  nativeName: string;
  languageName: string;
  hreflang: string;
  dir: "ltr" | "rtl";
};

export const locales: LocaleConfig[] = [
  { id: "en", name: "English", nativeName: "English", languageName: "English", hreflang: "en", dir: "ltr" },
  { id: "zh", name: "Chinese", nativeName: "中文", languageName: "Chinese", hreflang: "zh-CN", dir: "ltr" },
  { id: "es", name: "Spanish", nativeName: "Español", languageName: "Spanish", hreflang: "es", dir: "ltr" },
  { id: "fr", name: "French", nativeName: "Français", languageName: "French", hreflang: "fr", dir: "ltr" },
  { id: "de", name: "German", nativeName: "Deutsch", languageName: "German", hreflang: "de", dir: "ltr" },
  { id: "ja", name: "Japanese", nativeName: "日本語", languageName: "Japanese", hreflang: "ja", dir: "ltr" },
  { id: "ko", name: "Korean", nativeName: "한국어", languageName: "Korean", hreflang: "ko", dir: "ltr" },
  { id: "pt", name: "Portuguese", nativeName: "Português", languageName: "Portuguese", hreflang: "pt", dir: "ltr" },
  { id: "it", name: "Italian", nativeName: "Italiano", languageName: "Italian", hreflang: "it", dir: "ltr" },
  { id: "ru", name: "Russian", nativeName: "Русский", languageName: "Russian", hreflang: "ru", dir: "ltr" },
  { id: "ar", name: "Arabic", nativeName: "العربية", languageName: "Arabic", hreflang: "ar", dir: "rtl" },
  { id: "hi", name: "Hindi", nativeName: "हिन्दी", languageName: "Hindi", hreflang: "hi", dir: "ltr" }
];

export const supportedLocales = locales.map((locale) => locale.id);

export function isLocale(value: string): value is Locale {
  return supportedLocales.includes(value as Locale);
}

export function localeFromBrowserLanguages(browserLanguages: readonly string[] | undefined): Locale {
  const candidates = browserLanguages?.length ? browserLanguages : ["en"];

  for (const language of candidates) {
    const normalized = language.toLowerCase();
    const exact = normalized.split("-")[0];

    if (isLocale(normalized)) {
      return normalized;
    }

    if (exact && isLocale(exact)) {
      return exact;
    }
  }

  return "en";
}

export function getLocale(locale: Locale): LocaleConfig {
  return locales.find((candidate) => candidate.id === locale) ?? locales[0];
}
